module.exports = __webpack_public_path__ + "static/chris-25a30e3e831fd66570471ac0fb045668.jpg";